var render, staticRenderFns
import script from "./floatingFrame.vue?vue&type=script&lang=js"
export * from "./floatingFrame.vue?vue&type=script&lang=js"
import style0 from "./floatingFrame.vue?vue&type=style&index=0&id=78a8a3b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports